import { Box, Typography } from "@mui/material";
import pageNotFound from "../../../assets/images/pageNotFound.svg";

export const PageNotFound = () => {
  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      height={"100vh"}
    >
      <Box>
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
          <img src={pageNotFound} />
        </Box>
        <Typography variant={"h6"} color={"textSecondary"} align={"center"}>
          Ops... Esta página não existe.
        </Typography>
      </Box>
    </Box>
  );
};
export default PageNotFound;
